import React, { useState } from "react";
import { Link } from "react-router-dom";
import { dummyDeposits } from "../../../data/dummyData";
import "../Home/Homepage.css";
import "./FundsDepositPage.css";

const formatDate = (iso) => {
  try {
    const d = new Date(iso);
    return d.toLocaleString("en-IN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
};

const truncateHash = (str, head = 8, tail = 6) => {
  if (!str || str.length <= head + tail) return str;
  return `${str.slice(0, head)}...${str.slice(-tail)}`;
};

const FundsDepositPage = () => {
  const [deposits] = useState(dummyDeposits);
  const [search, setSearch] = useState("");

  const filtered = deposits.filter(
    (d) =>
      d.user_id?.toLowerCase().includes(search.toLowerCase()) ||
      d.emailId?.toLowerCase().includes(search.toLowerCase()) ||
      d.transaction_hash?.toLowerCase().includes(search.toLowerCase()) ||
      d.currency?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <main className="dashboard-main dashboard-subpage">
      <section className="dashboard-hero">
        <div className="dashboard-hero__text">
          <p className="dashboard-hero__breadcrumb">
            <Link to="/dashboard/homepage">Dashboard</Link>
            <span style={{ margin: "0 0.35rem" }}>/</span>
            <span>Deposit</span>
          </p>
          <h1 className="dashboard-hero__title">Deposit</h1>
          <p className="dashboard-hero__subtitle">
            Manage deposit requests and history
          </p>
        </div>
        <div className="dashboard-hero__icon">
          <i className="fas fa-arrow-down" />
        </div>
      </section>

      <div className="dashboard-body">
        <section className="deposits-section">
          <div className="deposits-section__header">
            <div className="deposits-section__title-wrap">
              <span className="deposits-section__icon">
                <i className="fas fa-wallet" />
              </span>
              <h2 className="deposits-section__title">Deposit History</h2>
            </div>
            <div className="deposits-section__stats">
              <span className="deposits-stat">
                <strong>{deposits.length}</strong> Deposits
              </span>
              <span className="deposits-stat">
                <strong>{deposits.filter((d) => d.status === "SUCCESS").length}</strong> Success
              </span>
            </div>
          </div>
          <div className="deposits-search-wrap">
            <i className="fas fa-search" />
            <input
              type="text"
              placeholder="Search by user ID, email, tx hash or currency..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="deposits-search-input"
            />
          </div>
          <div className="deposits-table-wrap">
            <table className="deposits-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Created</th>
                  <th>User ID</th>
                  <th>Email</th>
                  <th>Mobile</th>
                  <th>Chain</th>
                  <th>Currency</th>
                  <th>Amount</th>
                  <th>From Address</th>
                  <th>To Address</th>
                  <th>Tx Hash</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((row) => (
                  <tr key={row.index}>
                    <td>{row.index}</td>
                    <td>{formatDate(row.createdAt)}</td>
                    <td><span className="deposits-mono">{row.user_id}</span></td>
                    <td>{row.emailId}</td>
                    <td>{row.mobileNumber}</td>
                    <td>{row.chain}</td>
                    <td><strong>{row.short_name || row.currency}</strong></td>
                    <td>{typeof row.amount === "number" ? row.amount.toLocaleString("en-IN", { maximumFractionDigits: 4 }) : row.amount}</td>
                    <td><span className="deposits-hash" title={row.from_address}>{truncateHash(row.from_address)}</span></td>
                    <td><span className="deposits-hash" title={row.to_address}>{truncateHash(row.to_address)}</span></td>
                    <td><span className="deposits-hash" title={row.transaction_hash}>{truncateHash(row.transaction_hash, 10, 8)}</span></td>
                    <td>
                      <span className={`deposits-status deposits-status--${(row.status || "").toLowerCase()}`}>
                        {row.status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {filtered.length === 0 && (
            <p className="deposits-empty">No deposits match your search.</p>
          )}
        </section>
      </div>
    </main>
  );
};

export default FundsDepositPage;
